/**
 * Rota segmentlerinden (URL path parçası) Türkçe breadcrumb etiketine eşleme.
 * Anahtarlar Home.tsx'teki <Route path> tanımlarıyla birebir aynıdır.
 *
 * Eskiden breadcrumb, biriken URL segmentlerini doğrudan i18n'e (`t(url)`)
 * veriyordu; çeviri bulunamadığında ham path (ör. "companydetails/16dac9...")
 * ekrana basılıyordu. Bu harita eksiksiz olmayabilir — bilinmeyen bir segment
 * sessizce atlanır, çirkin ham metin göstermek yerine.
 */
export const ROUTE_LABELS: Record<string, string> = {
    users: 'Kullanıcılar',
    profile: 'Profilim',
    perioddefinition: 'Dönem Tanımlama',
    targetaudiencedefinition: 'Hedef Kitle Tanımlama',
    scaledefinition: 'Skala Tanımlama',
    performancesystemsdefinition: 'Performans Sistemleri Tanımlama',
    parameters: 'Parametreler',
    systemrole: 'Roller ve Yetkiler',
    userrole: 'Kullanıcı Rolü',
    oneononemeetingschedule: 'Performans Takvimi Tanımlama',
    performancecardscreation: 'Performans Kartları Oluşturma',
    strategicokrentry: 'Stratejik OKR Girişi',
    departmentokrentry: 'Departman OKR Girişi',
    corporategoalcardentry: 'Kurum Hedef Kartı Girişi',
    departmentgoalcardentry: 'Departman Hedef Kartı Girişi',
    corporategoalresultentry: 'Kurum Hedef Sonuç Girişi',
    departmentgoalresultentry: 'Departman Hedef Sonuç Girişi',
    competencyentry: 'Yetkinlik Girişi',
    competencyroleentry: 'Yetkinlik - Rol Eşleştirme',
    myperformancecardsstrategicokrs: "OKR'larım",
    myperformancecardskpis: "KPI'larım",
    mycompetencies: 'Yetkinliklerim',
    myteamscompetencies: 'Ekibimin Yetkinlikleri',
    adminperformancecardsokr: 'Bütün OKR Kartları',
    adminperformancecardskpi: 'Bütün KPI Kartları',
    adminindividualkpicards: 'KPI Kartları',
    dashboardmyteamsokrs: "Ekibimin OKR'ları",
    myteamskpis: "Ekibimin KPI'ları",
    dashboardstrategicokrs: "Stratejik OKR'lar",
    myperformancecardsdepartmentokrs: "Departman OKR'ları",
    myfeedbacksoutgoing: 'Verdiğim Geribildirimler',
    myfeedbacksincoming: 'Aldığım Geribildirimler',
    myfeedbacksmyteams: 'Ekibimin Aldığı Geribildirimler',
    mydialogsteam: 'Çalışanlarımla',
    mydialogsmanager: 'Yöneticimle',
    mydialogsmyteams: "Ekibimin 1-1'leri",
    kpipool: 'KPI Havuzu',
    myperformanceresults: 'Performans Sonuçlarım',
    managerevaluation: 'Yönetici Değerlendirmesi',
    calibrationevaluation: 'Kalibrasyon Değerlendirmesi',
    managerevaluationsettings: 'Yönetici Değerlendirmeleri',
    reports: 'Raporlar',
    nudgingemails: 'Dürtme Mailleri',
    dashboardscreens: 'Dashboard Ekranları',
    logviewer: 'Sistem Logları',
    company_groups: 'Şirketler',
    companies: 'Şirket Grubu',
    companydetails: 'Şirket Detayı',
};

/** "8-4-4-4-12" biçimindeki UUID'leri tespit eder. */
const GUID_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export const isGuidSegment = (segment: string): boolean => GUID_PATTERN.test(segment);
